import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { CheckCircle, Check } from '@phosphor-icons/react'

const FormNavButtons = ({
  currentStep = 0,
  totalSteps = 0,
  onNext = () => {},
  onBack = () => {},
  onSubmit = () => {},
  onDiscardChanges = () => {},
  isSubmitting = false,
  isEdit = false,
  hasUnsavedChanges = false,
  display = true,
  nextButtonRef = null,
}) => {
  const { t } = useTranslation(['reservations', 'common'])
  const isFirstStep = currentStep === 0
  const isLastStep = currentStep === totalSteps - 1

  const handleNext = () => {
    if (isLastStep || isEdit) {
      onSubmit?.()
    } else {
      onNext?.()
    }
  }

  const getPrimaryButtonText = () => {
    if (isLastStep) {
      return isSubmitting
        ? t('reservations:amenityForms.formNavButtons.creating')
        : t('reservations:amenityForms.formNavButtons.createAmenity')
    }
    if (isEdit) {
      return t('reservations:amenityForms.formNavButtons.saveChanges')
    }
    return t('reservations:shared.next')
  }

  if (!display) {
    return null
  }

  return (
    <div className="form-nav-buttons">
      {!isFirstStep && !isEdit && (
        <button type="button" onClick={onBack} className="button button-gray auto-width">
          {t('common:actions.back')}
        </button>
      )}
      {isEdit && (
        <button
          type="button"
          onClick={onDiscardChanges}
          disabled={isSubmitting || !hasUnsavedChanges}
          className="button button-transparent auto-width"
        >
          {t('reservations:amenityForms.formNavButtons.discardChanges')}
        </button>
      )}
      <button
        type="button"
        ref={nextButtonRef}
        onClick={handleNext}
        disabled={isSubmitting || (isEdit && !hasUnsavedChanges)}
        className="button button-primary auto-width"
      >
        {isLastStep && !isEdit && <CheckCircle size={20} />}
        {isEdit && <Check size={20} />}
        {getPrimaryButtonText()}
      </button>
    </div>
  )
}

FormNavButtons.propTypes = {
  currentStep: PropTypes.number.isRequired,
  totalSteps: PropTypes.number.isRequired,
  onNext: PropTypes.func,
  onBack: PropTypes.func,
  onSubmit: PropTypes.func,
  onDiscardChanges: PropTypes.func,
  isSubmitting: PropTypes.bool,
  nextButtonRef: PropTypes.object,
}

export default FormNavButtons
